<template>
  <div>
    <el-form label-width="120px" :model="ruleForm">
      <el-form-item label="活动参与对象:" prop="partner">
        <el-checkbox-group
          v-model="partner"
          @change="checkListchange"
          :disabled="isStart"
        >
          <el-checkbox label="-1">全部</el-checkbox>
          <el-checkbox
            v-for="(item, index) in levelList"
            :key="index"
            :label="item.value"
            :disabled="partner == -1"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div style="display: flex">
          <span>入会时间：</span>
          <el-checkbox
            v-model="ruleForm.firstOpenCardTimeType"
            :true-label="2"
            :false-label="0"
            :disabled="isStart"
            >指定时间段</el-checkbox
          >
          <div class="my_select_time" style="margin-left: 8px">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="ruleForm.openCardStartTime"
              type="datetime"
              placeholder="开始日期"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 185px; font-size: 12px"
              class="time1"
              :clearable="false"
              :disabled="ruleForm.firstOpenCardTimeType != 2 || isStart"
            >
            </el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="ruleForm.openCardEndTime"
              type="datetime"
              placeholder="结束日期"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 200px; font-size: 12px"
              class="time2"
              :picker-options="openCardEndTimeOptionsValue"
              :clearable="false"
              :disabled="ruleForm.firstOpenCardTimeType != 2 || isStart"
            >
            </el-date-picker>
            <i
              v-if="ruleForm.firstOpenCardTimeType == 2"
              class="el-icon-circle-close date_icon1"
              @click="clearNewTime"
            ></i>
            <img
              src="@/assets/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
        </div>
        <span style="color: red">注意：该条件对【非会员】身份不生效</span>
      </el-form-item>
      <el-form-item label="Plus会员身份:" required>
        <el-radio v-model="ruleForm.plusObject" :label="0" :disabled="isStart"
          >不限</el-radio
        >
        <el-radio v-model="ruleForm.plusObject" :label="1" :disabled="isStart"
          >Plus会员</el-radio
        >
        <el-radio v-model="ruleForm.plusObject" :label="2" :disabled="isStart"
          >非plus会员</el-radio
        >
        <div style="color: red">
          注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
        </div>
      </el-form-item>
      <el-form-item label="活动条件:">
        <el-checkbox
          v-model="ruleForm.condFollow"
          :disabled="isStart"
          :true-label="1"
          :false-label="0"
        >
          关注店铺后方可参与活动
        </el-checkbox></el-form-item
      >
    </el-form>
  </div>
</template>

<script>
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
export default {
  model: {
    prop: "ruleForm",
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    // 是否编辑
    isStart: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.getLevel();
  },
  watch: {},
  computed: {
    partner: {
      get() {
        const partner = this.ruleForm.allowLevel
          ? this.ruleForm.allowLevel.split(",")
          : [];
        console.log(partner);
        return partner;
      },
      set(val) {
        this.ruleForm.allowLevel = val.join(",");
      },
    },
  },
  data() {
    return {
      levelList: [],
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleForm.openCardEndTime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleForm.openCardStartTime).valueOf()
          );
        },
      },
    };
  },
  methods: {
    verify() {
      return new Promise((resolve, reject) => {
        if (this.partner.length == 0) {
          this.$message.warning("请选择会员等级");
          reject();
        } else if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleForm.openCardStartTime || !this.ruleForm.openCardEndTime)
        ) {
          this.$message.warning("请选择入会时间");
          reject();
        } else {
          resolve();
        }
      });
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleForm.openCardStartTime = "";
      this.ruleForm.openCardEndTime = "";
    },
    //选中改变
    checkListchange(val) {
      if (val.includes("-1")) {
        this.partner = ["-1"];
      } else if (val.length == this.levelList.length) {
        this.partner = ["-1"];
      }
      if (val.length > 0) {
        // this.ruleForm.allowLevel = val.join(",");
      }
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        let levelList = [
          {
            label: "非会员",
            value: "0",
          },
        ];
        res.data.forEach((item) => {
          levelList.push({
            label: item.customerLevelName,
            value: String(item.customerLevel),
          });
        });
        this.levelList = levelList;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
